module.exports = __webpack_public_path__ + "img/inrDecrease.83882f7b.svg";